export enum EKanbanTicketType {
    New = 'New',
    Icebox = 'Icebox',
    Started = 'Started',
    Holded = 'Holded',
    Finished = 'Finished',
    Tested = 'Tested',
    Delivered = 'Delivered',
    Accepted = 'Accepted',
}